/* MXC Designs - ATC Animation + CRO Enhancements */
(function () {

  /* ============================================================
     1. ADD TO CART ANIMATION
     ============================================================ */
  function initATCAnimation() {
    document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(attachToForm);
    new MutationObserver(() => {
      document.querySelectorAll('[data-type="add-to-cart-form"]:not([data-null-bound])').forEach(attachToForm);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function attachToForm(form) {
    if (form.dataset.nullBound) return;
    form.dataset.nullBound = 'true';
    const btn = form.querySelector('.product-form__submit');
    if (!btn) return;

    form.addEventListener('submit', function () {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      // Ripple
      const ripple = document.createElement('span');
      ripple.classList.add('null-ripple-el');
      ripple.style.top = '50%';
      ripple.style.left = '50%';
      btn.appendChild(ripple);
      setTimeout(() => ripple.remove(), 600);

      // Pop
      btn.classList.remove('null-atc-animate');
      void btn.offsetWidth;
      btn.classList.add('null-atc-animate');

      // Success flash
      const originalHTML = btn.innerHTML;
      setTimeout(() => {
        btn.classList.add('null-atc-success');
        btn.innerHTML = '<span>✓ Added!</span>';
        setTimeout(() => {
          btn.classList.remove('null-atc-success', 'null-atc-animate');
          btn.innerHTML = originalHTML;
        }, 1600);
      }, 300);
    });
  }

  /* ============================================================
     2. TRUST BADGE STRIP (below ATC on product pages)
     Free-shipping badge removed Oct 21 (offer was dropped);
     replaced with the opt-in $4.99 shipping protection.
     ============================================================ */
  function injectTrustBadges() {
    if (document.getElementById('null-trust-strip')) return;
    const target = document.querySelector('.product-form__buttons');
    if (!target) return;

    const strip = document.createElement('div');
    strip.id = 'null-trust-strip';
    strip.innerHTML = `
      <div class="null-trust-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
        <span>Ships in 1-3 days</span>
      </div>
      <div class="null-trust-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
        <span>Secure checkout</span>
      </div>
      <div class="null-trust-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6l8-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>
        <span>Shipping protection</span>
      </div>
    `;
    target.insertAdjacentElement('afterend', strip);
  }

  /* ============================================================
     3. STICKY MOBILE ATC BAR
     Appears when the main ATC button scrolls off screen
     ============================================================ */
  function initStickyATC() {
    if (window.innerWidth > 749) return;
    const mainBtn = document.querySelector('.product-form__submit');
    if (!mainBtn || document.getElementById('null-sticky-atc')) return;

    const rawTitle = document.querySelector('.product__title h1, .product__title h2')?.textContent?.trim() || '';
    const title = rawTitle.length > 28 ? rawTitle.slice(0, 28) + '…' : rawTitle;
    const price = document.querySelector('.price__regular .price-item, .price-item--regular')?.textContent?.trim() || '';

    const bar = document.createElement('div');
    bar.id = 'null-sticky-atc';
    bar.innerHTML = `
      <div class="null-sticky-atc__inner">
        <div class="null-sticky-atc__info">
          <span class="null-sticky-atc__name">${title}</span>
          <span class="null-sticky-atc__price">${price}</span>
        </div>
        <button class="null-sticky-atc__btn" type="button">Add to Cart</button>
      </div>
    `;
    document.body.appendChild(bar);

    bar.querySelector('.null-sticky-atc__btn').addEventListener('click', () => {
      mainBtn.click();
      mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    new IntersectionObserver(
      ([entry]) => bar.classList.toggle('null-sticky-atc--show', !entry.isIntersecting),
      { rootMargin: '0px 0px -10px 0px' }
    ).observe(mainBtn);
  }

  /* ============================================================
     4. LOW STOCK URGENCY STYLING
     ============================================================ */
  function styleInventory() {
    const inv = document.querySelector('.product__inventory');
    if (!inv) return;
    const text = inv.textContent.toLowerCase();
    if (text.includes('low stock') || /\b[1-5]\s+(left|remaining|in stock)/i.test(text)) {
      inv.classList.add('null-inv-urgent');
    }
  }

  /* ============================================================
     5. SALE BADGE UPGRADE
     ============================================================ */
  function upgradeSaleBadges() {
    document.querySelectorAll('.badge--sale, .badge--on-sale').forEach(b => b.classList.add('null-sale-badge'));
  }

  /* ============================================================
     6. COLLECTION PAGE - SELLING FAST BADGES
     Adds a subtle badge to products marked with a 'selling-fast' tag
     ============================================================ */
  function injectSellingFastBadges() {
    document.querySelectorAll('[data-product-id]').forEach(card => {
      const tags = card.dataset.productTags || '';
      if (tags.includes('selling-fast') || tags.includes('bestseller')) {
        const media = card.querySelector('.card__media, .card-product__image');
        if (media && !media.querySelector('.null-selling-fast')) {
          const badge = document.createElement('div');
          badge.className = 'null-selling-fast';
          badge.textContent = '🔥 Selling Fast';
          media.appendChild(badge);
        }
      }
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initATCAnimation();
    injectTrustBadges();
    initStickyATC();
    styleInventory();
    upgradeSaleBadges();
    injectSellingFastBadges();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
